"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Page500 = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var layout_1 = require("../_shared/components/layout");
var react_router_dom_1 = require("react-router-dom");
var index_1 = require("../_shared/reducers/index");
var Page500 = /** @class */ (function (_super) {
    __extends(Page500, _super);
    function Page500(props) {
        return _super.call(this, props) || this;
    }
    Page500.prototype.logout = function () {
        this.props.history.replace('login');
        this.props.logout();
    };
    Page500.prototype.render = function () {
        var _this = this;
        return (React.createElement(layout_1.Page, { id: "internal-server-error-page" },
            React.createElement(layout_1.Column, null,
                React.createElement(layout_1.Column, { alignItems: "center", justifyContent: "center" },
                    "Je hebt niet genoeg rechten",
                    React.createElement(react_router_dom_1.Link, { to: "/dashboard", className: "go-back" }, "Go Back"),
                    React.createElement("a", { onClick: function () { return _this.logout(); } }, " Logout ")))));
    };
    return Page500;
}(React.Component));
exports.Page500 = Page500;
var mapDispatchToProps = function (dispatch) { return ({
    logout: function () { return index_1.LoginActions.logout()(dispatch); },
}); };
var Container = (0, react_redux_1.connect)(null, mapDispatchToProps)(layout_1.Page);
exports.default = Container;
